export const skillStatusType = {
    DRAFT: 1,
    SME_APPROVED: 2,
    SA_APPROVED: 3,
    PUBLISHED: 4,
    RETIRED: 5
}